import { render, staticRenderFns } from "./shouyin.vue?vue&type=template&id=357e18ad&scoped=true&"
import script from "./shouyin.vue?vue&type=script&lang=js&"
export * from "./shouyin.vue?vue&type=script&lang=js&"
import style0 from "./shouyin.vue?vue&type=style&index=0&id=357e18ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e18ad",
  null
  
)

export default component.exports